(function () {
    'use strict';

    window.addEventListener('load', function () {
        document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
            var viewport = carousel.querySelector('[data-carousel-viewport]');
            var track = carousel.querySelector('[data-carousel-track]');
            var originalSlides = Array.prototype.slice.call(
                carousel.querySelectorAll('[data-carousel-slide]'),
            );
            var previous = carousel.querySelector('[data-carousel-prev]');
            var next = carousel.querySelector('[data-carousel-next]');
            var dots = Array.prototype.slice.call(
                carousel.querySelectorAll('[data-carousel-dot]'),
            );
            var slides;
            var count = originalSlides.length;
            var index = count > 1 ? count : 0;
            var isAnimating = false;
            var isDragging = false;
            var isHovered = false;
            var isFocused = false;
            var suppressClick = false;
            var startX = 0;
            var dragX = 0;
            var baseOffset = 0;
            var autoplayTimer = null;
            var animationTimer = null;
            var autoplayDelay = 5000;

            if (!viewport || !track || !count) return;

            function makeClone(slide) {
                var clone = slide.cloneNode(true);
                clone.removeAttribute('id');
                clone.setAttribute('aria-hidden', 'true');
                clone.setAttribute('data-carousel-clone', 'true');

                clone.querySelectorAll('img').forEach(function (image) {
                    image.loading = 'eager';
                    image.removeAttribute('loading');
                    image.setAttribute('draggable', 'false');
                });

                return clone;
            }

            if (count > 1) {
                var before = document.createDocumentFragment();
                var after = document.createDocumentFragment();

                originalSlides.forEach(function (slide) {
                    before.appendChild(makeClone(slide));
                });
                originalSlides.forEach(function (slide) {
                    after.appendChild(makeClone(slide));
                });

                track.insertBefore(before, originalSlides[0]);
                track.appendChild(after);
            }

            slides = Array.prototype.slice.call(
                track.querySelectorAll('[data-carousel-slide]'),
            );

            slides.forEach(function (slide) {
                var link = slide.querySelector('.carousel__link');

                if (!link) {
                    return;
                }

                link.addEventListener(
                    'click',
                    function (event) {
                        if (window.innerWidth >= 1024) {
                            return;
                        }

                        if (suppressClick) {
                            event.preventDefault();
                            event.stopPropagation();
                            suppressClick = false;

                            return;
                        }

                        if (!slide.classList.contains('is-active')) {
                            event.preventDefault();
                            event.stopPropagation();

                            slides.forEach(function (item) {
                                item.classList.remove('is-active');
                            });

                            slide.classList.add('is-active');
                        }
                    },
                    true,
                );
            });

            function getSlideOffset(slide) {
                var trackRect = track.getBoundingClientRect();
                var slideRect = slide.getBoundingClientRect();

                return slideRect.left - trackRect.left;
            }

            function update(animate) {
                var slide = slides[index];
                if (!slide) return;

                let firstSpace = 0;
                if (window.innerWidth > 1200) {
                    firstSpace = 90;
                }

                var slideRect = slide.getBoundingClientRect();
                var slideOffset = getSlideOffset(slide) - firstSpace;
                var offset = (viewport.clientWidth - slideRect.width) / 2 - slideOffset;

                baseOffset = offset;

                if (animate === false) track.style.transition = 'none';
                track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';

                if (animate === false) {
                    track.offsetHeight;
                    track.style.transition = '';
                }

                var dotIndex = count > 1 ? (index - count + count) % count : 0;
                dots.forEach(function (dot, i) {
                    var active = i === dotIndex;
                    dot.classList.toggle('is-active', active);
                    dot.setAttribute('aria-current', active ? 'true' : 'false');
                });
            }

            function normalizeLoop() {
                if (count < 2) return;

                if (index < count) {
                    index += count;
                    update(false);
                } else if (index >= count * 2) {
                    index -= count;
                    update(false);
                }
            }

            function finishAnimation() {
                if (!isAnimating) return;

                if (animationTimer) {
                    window.clearTimeout(animationTimer);
                    animationTimer = null;
                }

                normalizeLoop();
                isAnimating = false;
                startAutoplay();
            }

            function scheduleAnimationFinish() {
                if (animationTimer) {
                    window.clearTimeout(animationTimer);
                }

                animationTimer = window.setTimeout(finishAnimation, 500);
            }

            function move(step) {
                if (count < 2 || isAnimating || isDragging) return;

                isAnimating = true;
                index += step;
                update(true);
                scheduleAnimationFinish();
            }

            function startAutoplay() {
                stopAutoplay();

                if (count < 2 || isHovered || isFocused || isDragging) return;

                autoplayTimer = window.setInterval(function () {
                    move(1);
                }, autoplayDelay);
            }

            function stopAutoplay() {
                if (autoplayTimer) {
                    window.clearInterval(autoplayTimer);
                    autoplayTimer = null;
                }
            }

            function finishDrag() {
                if (!isDragging) return;

                isDragging = false;
                viewport.classList.remove('is-dragging');

                var threshold = Math.max(50, viewport.clientWidth * 0.02);
                var distance = dragX;

                dragX = 0;

                if (Math.abs(distance) >= threshold) {
                    suppressClick = true;

                    track.style.transition = '';
                    move(distance < 0 ? 1 : -1);

                    return;
                }

                suppressClick = false;

                track.style.transition = '';
                update(true);
                startAutoplay();
            }

            viewport.addEventListener('pointerdown', function (event) {
                if (count < 2 || isAnimating) return;

                isDragging = true;
                startX = event.clientX;
                dragX = 0;
                stopAutoplay();

                if (window.innerWidth >= 1024) return;
                viewport.classList.add('is-dragging');
                viewport.setPointerCapture(event.pointerId);
                track.style.transition = 'none';
            });

            viewport.addEventListener('pointermove', function (event) {
                if (!isDragging) return;

                dragX = event.clientX - startX;

                if (Math.abs(dragX) > 5) {
                    event.preventDefault();
                }

                track.style.transform =
                    'translate3d(' + (baseOffset + dragX) + 'px, 0, 0)';
            });


            viewport.addEventListener('pointerup', finishDrag);
            viewport.addEventListener('pointercancel', finishDrag);
            viewport.addEventListener('lostpointercapture', finishDrag);

            // A drag must not activate the link under the pointer on release.
            viewport.addEventListener(
                'click',
                function (event) {
                    if (suppressClick) {
                        event.preventDefault();
                        event.stopPropagation();
                        suppressClick = false;
                    }
                },
                true,
            );

            if (previous) {
                previous.addEventListener('click', function () {
                    stopAutoplay();
                    move(-1);
                });
            }

            if (next) {
                next.addEventListener('click', function () {
                    stopAutoplay();
                    move(1);
                });
            }

            dots.forEach(function (dot) {
                dot.addEventListener('click', function () {
                    if (isAnimating || isDragging) return;

                    stopAutoplay();
                    isAnimating = true;
                    index = count + Number(dot.dataset.carouselDot);
                    update(true);
                    scheduleAnimationFinish();
                });
            });

            carousel.addEventListener('mouseenter', function () {
                isHovered = true;
                stopAutoplay();
            });

            carousel.addEventListener('mouseleave', function () {
                isHovered = false;
                startAutoplay();
            });

            carousel.addEventListener('focusin', function () {
                isFocused = true;
                stopAutoplay();
            });

            carousel.addEventListener('focusout', function (event) {
                if (!carousel.contains(event.relatedTarget)) {
                    isFocused = false;
                    startAutoplay();
                }
            });

            track.addEventListener('transitionend', function (event) {
                if (event.target === track && event.propertyName === 'transform') {
                    finishAnimation();
                }
            });

            track.addEventListener('transitioncancel', function (event) {
                if (event.target === track && event.propertyName === 'transform') {
                    finishAnimation();
                }
            });

            window.addEventListener(
                'resize',
                function () {
                    update(false);
                },
                { passive: true },
            );

            update(false);
            startAutoplay();
        });
    });
}());
